import { render, staticRenderFns } from "./Amortize.vue?vue&type=template&id=23af1933&"
import script from "./Amortize.vue?vue&type=script&lang=ts&"
export * from "./Amortize.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23af1933')) {
      api.createRecord('23af1933', component.options)
    } else {
      api.reload('23af1933', component.options)
    }
    module.hot.accept("./Amortize.vue?vue&type=template&id=23af1933&", function () {
      api.rerender('23af1933', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/account-payables/reports/Amortize.vue"
export default component.exports